export enum PureQueue {
  COMFY_ACTION_STATUS = 'COMFY_ACTION_STATUS',
  COMFY_TRIGGER_STATUS = 'COMFY_TRIGGER_STATUS',
  RSU = 'RSU',
  RITA = 'RITA',
}
